import * as React from "react";
import { CoughReOpenCommentGroup } from "../../../../misc/api/apiTypes";
import DropdownCommentsModal, { BaseDropdownModalProps } from "../DropdownCommentsModal/DropdownCommentsModal";
import { GetSelectedOptions, DropdownCommentTypes, ValidateSubmittedComments, ShouldDisplay } from "../DropdownCommentsModal/DropdownCommentsHelpers";
import { connect } from "react-redux";
import { MainState } from "../../../../Core/reducers";
import { useWebPortalLegacyClient } from "../../../../misc/api/WebPortalTokenClient";

interface EditReviewCompleteCommentsModalProps extends BaseDropdownModalProps, EditReviewCompleteCommentsModalOwnProps {
    
}

interface EditReviewCompleteCommentsModalOwnProps {
    onClose: () => void;
    analysisSetId: string;
    isAnalysisSetLinked: boolean;
    selectedDropdownCommentType: DropdownCommentTypes;
}

function ValidateEditComments(auditAnnotation: string): string[] {

    const errors = [];

    if (!auditAnnotation.trim()) {
        errors.push("Editing a review complete comment requires a free text input.");
    }

    return errors;
}

const EditReviewCompleteCommentsModal = ({ analysisSetId, selectedDropdownCommentType, ...props }: EditReviewCompleteCommentsModalProps): JSX.Element => {
    const legacyClient = useWebPortalLegacyClient();

    const updateReviewCompleteComments = (selectedComments: CoughReOpenCommentGroup[], auditAnnotation: string) => {
        return legacyClient.updateReviewCompleteComments(analysisSetId, auditAnnotation, GetSelectedOptions(selectedComments));
    }

    const fetchReOpenComments = () => {
        return legacyClient.getReviewCompleteFixedCommentsForSet(analysisSetId);
    }

    const validateReOpenReasons = (selectedComments: CoughReOpenCommentGroup[], auditAnnotation: string): string[] => {
        return ValidateSubmittedComments(selectedComments).concat(ValidateEditComments(auditAnnotation));
    };

    const shouldDisplay = ShouldDisplay(DropdownCommentTypes.EditReviewComplete);

    return (shouldDisplay(analysisSetId, selectedDropdownCommentType) ? < DropdownCommentsModal loading = { false} editMode = { true} fetchFixedCommentsForAnalysisSet = { fetchReOpenComments } header = "Update Review Comments" showLinkedWarning = { false } saveFixedComments = { updateReviewCompleteComments } show = { selectedDropdownCommentType === DropdownCommentTypes.EditReviewComplete
} selectedCommentsValidator = { validateReOpenReasons } { ...props } /> : null);
};


function mapStateToProps(state: MainState, ownProps: EditReviewCompleteCommentsModalOwnProps): EditReviewCompleteCommentsModalProps {
    return {
        analysisSetId: ownProps.analysisSetId,
        isAnalysisSetLinked: ownProps.isAnalysisSetLinked,
        selectedDropdownCommentType: ownProps.selectedDropdownCommentType,
        onClose: ownProps.onClose
    };
}

export default connect<EditReviewCompleteCommentsModalProps, void, EditReviewCompleteCommentsModalOwnProps>(mapStateToProps)(EditReviewCompleteCommentsModal);
